import { Card, CardContent, Typography, Box, Chip } from '@mui/material';
import type { RiskAssessment } from '../utils/riskAssessment';

interface RiskScoreCardProps {
    risk: RiskAssessment;
}

const riskColor = (score: number): string => {
    if (score <= 3) return '#4caf50';
    if (score <= 6) return '#ff9800';
    return '#f44336';
};

const riskLabel = (score: number): string => {
    if (score <= 3) return 'Low Risk';
    if (score <= 6) return 'Moderate Risk';
    return 'High Risk';
};

export const RiskScoreCard = ({ risk }: RiskScoreCardProps) => {
    const color = riskColor(risk.score);

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Risk Score
                </Typography>
                <Box display="flex" alignItems="center" gap={2} mb={1.5}>
                    <Box
                        sx={{
                            width: 56,
                            height: 56,
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: color,
                            color: '#fff',
                        }}
                    >
                        <Typography variant="h5" fontWeight="bold">
                            {risk.score}
                        </Typography>
                    </Box>
                    <Typography variant="subtitle1" sx={{ color }}>
                        {riskLabel(risk.score)}
                    </Typography>
                </Box>
                <Box display="flex" flexWrap="wrap" gap={0.5}>
                    {risk.factors.map((factor, i) => (
                        <Chip key={i} label={factor} size="small" variant="outlined" />
                    ))}
                </Box>
            </CardContent>
        </Card>
    );
};
